import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import PortalIdParser from 'PortalIdParser';
import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import * as Scopes from 'automation-ui-enrollment/constants/Scopes';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentAssistanceTooltip = _ref => {
  let {
      children
    } = _ref,
    tooltipProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const aiSettingsLink = `/ai-settings/${PortalIdParser.get()}`;
  const tooltipMessage = useHasScope(Scopes.SUPER_ADMIN) ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      Link: UILink,
      Bold: 'b'
    },
    message: 'automation-ui-enrollment.aiAssistantFilterDescription.noAccess.settingsTooltipAdmin.contentAssistanceV2_jsx',
    options: {
      external: true,
      href: aiSettingsLink
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'automation-ui-enrollment.aiAssistantFilterDescription.noAccess.settingsTooltipNonAdmin.contentAssistanceV2'
  });
  return /*#__PURE__*/_jsx(UITooltip, Object.assign({
    title: tooltipMessage
  }, tooltipProps, {
    children: children
  }));
};
export default ContentAssistanceTooltip;